// The setup seat banner (Karan 23/10/2026). A platform admin can set a new
// company up from their own everyday account (its first Owner) before handing
// it to the real owner from the admin console. While that seat is active, the
// seat holder — and only them (their uid is on the org doc's setup.uid) — sees
// one slim line on every screen, desktop and phone, so they never forget whose
// company it is. The org doc is the one org.js already loaded; nothing extra is read.

/** PURE — the banner's text for this person, or null when it is not theirs to see. */
export function seatNotice(org, uid) {
  const s = org && org.setup;
  if (!s || typeof s !== 'object' || s.state !== 'active' || !uid || s.uid !== uid) return null;
  const b = (org.branding && typeof org.branding === 'object') ? org.branding : {};
  const company = String(b.displayName || org.name || 'this company').slice(0, 80);
  // Once the real owner has joined, the seat stays on as Track's IT admin
  // (Karan 23/10/2026: kept while testing; hand over whenever it's done).
  if (s.ownerJoinedAt) return `You’re in ${company} as Track’s IT admin.`;
  return `You’re setting up ${company} for its owner. When it’s ready, hand it over from the admin console.`;
}

/** PURE — the uid of the company's active setup seat (Track's IT admin), or null. */
export function seatHolderUid(org) {
  const s = org && org.setup;
  return s && typeof s === 'object' && s.state === 'active' && typeof s.uid === 'string' ? s.uid : null;
}
let seatUid = null;
let seatPhone = null;
/** The phone's seat line, or null: { text, company, ownerJoined } for its holder only. */
export const phoneSeat = () => seatPhone;
/** The active seat holder in the signed-in company, for the Team list's label. */
export const currentSeatUid = () => seatUid;

/**
 * Draw (or remove) the banner. Desktop: a line at the top of the content
 * column, above the header, on every screen. Phone: nothing is appended here;
 * the phone shell draws the line inside every screen from phoneSeat().
 */
export function showSetupSeat(org, uid, { phone = false } = {}) {
  seatUid = seatHolderUid(org);
  seatPhone = null;
  const text = seatNotice(org, uid);
  const old = document.getElementById('seat-banner');
  if (old) old.remove();
  document.documentElement.style.removeProperty('--seat-top');
  if (!text) return null;
  const b = document.createElement('div');
  b.id = 'seat-banner';
  b.className = `seat-banner${phone ? ' phone' : ''}`;
  b.setAttribute('role', 'status');
  b.textContent = text;                       // text only: never HTML from the org doc
  if (phone) {
    // v4.1.0 (Karan's mobile design, 23/10/2026): on the phone the line is drawn
    // INSIDE the screen, under the header, by the phone shell (mobile/shell.js
    // reads phoneSeat()) — not as a strip over the top of it.
    const s = org.setup || {};
    const br = (org.branding && typeof org.branding === 'object') ? org.branding : {};
    seatPhone = { text, company: String(br.displayName || org.name || 'this company').slice(0, 80), ownerJoined: !!s.ownerJoinedAt };
    try { window.dispatchEvent(new Event('track:seat')); } catch (_) { /* no window */ }
    return null;
  } else {
    const main = document.querySelector('.main');
    if (!main) return null;
    main.insertBefore(b, main.firstChild);
  }
  return b;
}
